import { render } from "./TextLinkWithArrow.vue?vue&type=template&id=0fef6cf5&scoped=true&ts=true"
import script from "./TextLinkWithArrow.vue?vue&type=script&lang=ts"
export * from "./TextLinkWithArrow.vue?vue&type=script&lang=ts"

import "./TextLinkWithArrow.vue?vue&type=style&index=0&id=0fef6cf5&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fef6cf5"]])

export default __exports__